export default __webpack_public_path__ + "static/media/wookaiOrangeIcon.4ebd4233.png";